import { render, staticRenderFns } from "./editRoles.vue?vue&type=template&id=6ff13014&scoped=true&"
import script from "./editRoles.vue?vue&type=script&lang=ts&"
export * from "./editRoles.vue?vue&type=script&lang=ts&"
import style0 from "./editRoles.vue?vue&type=style&index=0&id=6ff13014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff13014",
  null
  
)

export default component.exports